import { PinnedSidebarContext } from '@/contexts/pinned-sidebar.context'
import { useContext } from 'react'

export const usePinnedSidebar = () => {
  const context = useContext(PinnedSidebarContext)
  if (!context) throw new Error('usePinnedSidebar must be used within a PinnedSidebarProvider')
  return context
}
